import React, { Component } from 'react';

class AspectRatioContainer extends Component {

  constructor(props) {
    super(props);

    let classNames = 'eir-aspectratio';

    if(this.props.xs) {
      classNames = classNames + ' eir-aspectratio-' + this.props.xs;
    }

    if(this.props.sm) {
      classNames = classNames + ' eir-aspectratio-sm-' + this.props.sm;
    }

    if(this.props.md) {
      classNames = classNames + ' eir-aspectratio-md-' + this.props.md;
    }

    if(this.props.lg) {
      classNames = classNames + ' eir-aspectratio-lg-' + this.props.lg;
    }

    if(this.props.xl) {
      classNames = classNames + ' eir-aspectratio-xl-' + this.props.xl;
    }

    this.state = {
      classNames: classNames
    };
  }

  render() {
    return (
      <div className={this.state.classNames + ' ' + this.props.className}>
        {this.props.children}
      </div>
    );
  }
}

export default AspectRatioContainer;